export const QUESTION_TIMEOUT = 20 * 1000;
export const NUM_OF_QUIZ_QUESTIONS = 16;
export const ANSWERS_REVIEW_SCROLL_TOLERANCE = 40;
export const QUESTION_LANGUAGE = 'en';



// WEBPACK FOOTER //
// ./src/consts.js